import Toast from 'components/toast/toast';

export default Toast;
